import { Injectable, inject, Injector } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Route,
  CanActivateFn
} from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Role, AdministrationRole } from 'api/enums';
import { TryActivateResult } from './try-activate-result.enum';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
  constructor(
    private router: Router,
    private injector: Injector
  ) {}

  private get authService(): AuthenticationService {
    return this.injector.get(AuthenticationService);
  }
  canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean {
    const activationResult = this.tryActivate(activatedRoute.routeConfig);
    if (activationResult === TryActivateResult.NotLoggedIn) {
      return false;
    } else if (activationResult === TryActivateResult.NoAccess) {
      this.router.navigate(['/no-access']);
      return false;
    }

    return true;
  }

  tryActivate(route: Route): TryActivateResult {
    if (route.data && (route.data.userRoles || route.data.adminRoles)) {
      let roles = (route.data.userRoles || 0) as Role;
      let adminRoles = (route.data.adminRoles || 0) as AdministrationRole;

      if (!this.authService.hasAnyRole(roles, adminRoles)) {
        return TryActivateResult.NoAccess;
      }
    }

    return TryActivateResult.Success;
  }
}

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  return inject(AuthGuardService).canActivate(next, state);
};
